import React, { FC, LazyExoticComponent, Suspense } from "react";
import LoadingInstant from "../../pages/Utilities/LoadingInstant";
type T_SuspenseWrapperProps = {
  LazyLoadingComponent: LazyExoticComponent<React.FC<any>>;
};
const SuspenseWrapper: FC<T_SuspenseWrapperProps> = ({
  LazyLoadingComponent,
}) => {
  return (
    <Suspense fallback={<LoadingInstant />}>
      <LazyLoadingComponent />
    </Suspense>
  );
};
export default SuspenseWrapper;
